import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Checkbox } from "@/components/ui/checkbox";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useToast } from "@/hooks/use-toast";
import { CLINIC } from "@/constants/testIds";
import { PAYMENT_METHOD_LABELS } from "@/lib/patientConstants";

// Fix BC (2026-10-30): la clínica pidió sumar Cherry (financiación en cuotas) a "Aceptamos..." de la página.
const OPTIONS = ["cash", "zelle", "card", "transfer", "cherry", "other"];

/** Card de Ajustes: medios de pago que acepta la clínica, mostrados en la
 * landing y la página de reservas para que la paciente sepa cómo pagar. */
export default function AcceptedPaymentMethodsCard({ clinic, onUpdated }) {
  const [selected, setSelected] = useState(clinic.accepted_payment_methods || []);
  const [saving, setSaving] = useState(false);
  const { toast } = useToast();

  const toggle = (m) => setSelected((s) => (s.includes(m) ? s.filter((x) => x !== m) : [...s, m]));

  const handleSave = async () => {
    setSaving(true);
    try {
      const { data } = await api.put("/clinic", { accepted_payment_methods: selected });
      onUpdated(data);
      toast({ title: "Medios de pago actualizados" });
    } catch (err) {
      toast({ title: "Error al guardar", description: formatApiErrorDetail(err.response?.data?.detail), variant: "destructive" });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="bg-white border border-border rounded-xl p-6 sm:p-8 shadow-sm space-y-5" data-testid={CLINIC.paymentMethodsCard}>
      <div>
        <h2 className="font-serif text-xl text-foreground">Medios de pago aceptados</h2>
        <p className="text-sm text-muted-foreground mt-1">
          Se muestran en la landing y la página de reservas pública, para que la paciente sepa cómo puede pagar.
        </p>
      </div>
      <div className="flex flex-wrap gap-4">
        {OPTIONS.map((m) => (
          <label key={m} className="flex items-center gap-2 text-sm cursor-pointer">
            <Checkbox checked={selected.includes(m)} onCheckedChange={() => toggle(m)} data-testid={`${CLINIC.paymentMethodCheckboxPrefix}${m}`} />
            {PAYMENT_METHOD_LABELS[m]}
          </label>
        ))}
      </div>
      <Button onClick={handleSave} disabled={saving} className="bg-brand hover:bg-brand-hover text-white" data-testid={CLINIC.paymentMethodsSaveButton}>
        {saving ? "Guardando..." : "Guardar cambios"}
      </Button>
    </div>
  );
}
